import React, { Fragment, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const Products = () => {
  const sref = useRef(null);
  useEffect(() => {
    scrollToRef(sref);
  }, []);

  const scrollToRef = (ref) => ref.current.scrollIntoView();
  return (
    <Fragment>
      <Header name="Products" />
      <section
        className="breadcrumb_area breadcrumb2 bgimage biz_overlay"
        ref={sref}
      >
        <div className="bg_image_holder">
          <img src="img/breadbg2.jpg" alt="" />
        </div>
        <div className="container content_above">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb_wrapper d-flex flex-column align-items-center">
                <h4 className="page_title">Products</h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-tab-wrapper section-padding">
        <div className="tab service--tabs">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 sidebar">
                <div className="tab_nav tab_nav2 m-bottom-50">
                  <div
                    className="nav flex-column"
                    id="tab_nav1"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    <a
                      className="nav-link active"
                      id="v-pills-tab1"
                      data-toggle="pill"
                      href="#tab1"
                      role="tab"
                      aria-controls="tab1"
                      aria-selected="true"
                    >
                      Wet-End Starches (VijiCato, VijiCato-T)
                    </a>
                    <a
                      className="nav-link"
                      id="v-pills-tab2"
                      data-toggle="pill"
                      href="#tab2"
                      role="tab"
                      aria-controls="tab2"
                      aria-selected="false"
                    >
                      Spray Starches (VijiSpray/VijiSpray LG)
                    </a>
                    <a
                      className="nav-link"
                      id="v-pills-tab3"
                      data-toggle="pill"
                      href="#tab3"
                      role="tab"
                      aria-controls="tab3"
                      aria-selected="false"
                    >
                      Surface Starches (Native Starch/ Vijilox)
                    </a>
                    <a
                      className="nav-link"
                      id="v-pills-tab4"
                      data-toggle="pill"
                      href="#tab4"
                      role="tab"
                      aria-controls="tab4"
                      aria-selected="false"
                    >
                      Coating Starches(VIJICOAT/ VIJICOAT-T)
                    </a>
                    <a
                      className="nav-link"
                      id="v-pills-tab5"
                      data-toggle="pill"
                      href="#tab5"
                      role="tab"
                      aria-controls="tab5"
                      aria-selected="false"
                    >
                      VijiCol/VijiCoat CP, VijiBond
                    </a>
                    <a
                      className="nav-link"
                      id="v-pills-tab6"
                      data-toggle="pill"
                      href="#tab6"
                      role="tab"
                      aria-controls="tab6"
                      aria-selected="false"
                    >
                      VijiBond
                    </a>
                    <a
                      className="nav-link"
                      id="v-pills-tab7"
                      data-toggle="pill"
                      href="#tab7"
                      role="tab"
                      aria-controls="tab7"
                      aria-selected="false"
                    >
                      VijiSack P20
                    </a>
                    <a
                      className="nav-link"
                      id="v-pills-tab8"
                      data-toggle="pill"
                      href="#tab8"
                      role="tab"
                      aria-controls="tab8"
                      aria-selected="false"
                    >
                      Maize Starch
                    </a>
                    <a
                      className="nav-link"
                      id="v-pills-tab9"
                      data-toggle="pill"
                      href="#tab9"
                      role="tab"
                      aria-controls="tab9"
                      aria-selected="false"
                    >
                      VIJIGYP
                    </a>
                    <a
                      className="nav-link"
                      id="v-pills-tab10"
                      data-toggle="pill"
                      href="#tab10"
                      role="tab"
                      aria-controls="tab10"
                      aria-selected="false"
                    >
                      DRILLING GRADE (VIJIDRILL – DS & CMS)
                    </a>
                  </div>
                </div>
                <div className="download-widget m-bottom-30">
                  <div className="header">
                    <h6>Company Brochure</h6>
                  </div>
                  <div className="content">
                    {/* <img src="img/brochure.jpg" alt="" /> */}
                    <p>
                      <a
                        href="Vijaynagar_Biotech.pdf"
                        download
                        className="btn btn-secondary btn-sm btn-icon icon-left"
                      >
                        <i className="la la-cloud-download"></i> Download (PDF)
                      </a>
                      <span>165.64 KB</span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-9">
                <div className="tab-content" id="tabContent1">
                  <div
                    className="tab-pane fade show active"
                    id="tab1"
                    role="tabpanel"
                    aria-labelledby="tab1"
                  >
                    <div className="tab-image m-bottom-50">
                      <img src="img/used/prod1.png" alt="Product 1" />
                    </div>
                    <div className="contents-1">
                      <div className="m-bottom-30">
                        <div className="divider divider-simple text-left">
                          {/* <h3>Financial Overview &amp; Analysis</h3> */}
                        </div>
                      </div>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          Cationic starch shows existence of positively charged
                          particles that are strongly absorbed by negatively
                          charged cellulose fibres & filters.
                        </li>
                        <li className="list-item arrow-list4">
                          Improves the internal strength of paper/board.
                        </li>
                        <li className="list-item arrow-list4">
                          Improves ash percentage in paper/ board
                        </li>
                        <li className="list-item arrow-list4">
                          Our tailor made products have the DS ranging from 0.02
                          to 0.045 and other parameters can be customized as per
                          the customer requirements.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab2"
                    role="tabpanel"
                    aria-labelledby="tab2"
                  >
                    <div className="tab-image m-bottom-50">
                      <img src="img/used/prod2.png" alt="Product 2" />
                    </div>
                    <div className="contents-1">
                      <div className="m-bottom-30">
                        <div className="divider divider-simple text-left">
                          {/* <h3>Investment Planning</h3> */}
                        </div>
                      </div>
                      <p>
                        VijiSpray is a modified spray starch which possesses non
                        – ionic charge.
                      </p>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          Low Gelatinization Starch with gel temperature ranging
                          from 60 to 70 Deg C.
                        </li>
                        <li className="list-item arrow-list4">
                          Adhesive strength is consistent.
                        </li>
                      </ul>
                      <h4 className="mt-3">Advantages</h4>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          Improves ply bond strength.
                        </li>
                        <li className="list-item arrow-list4">
                          Higher retention of starch %.
                        </li>
                        <li className="list-item arrow-list4">
                          Reduction in ETP load
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab3"
                    role="tabpanel"
                    aria-labelledby="tab3"
                  >
                    <div className="tab-image m-bottom-50">
                      <img src="img/used/prod3.png" alt="Product 3" />
                    </div>
                    <div className="contents-1">
                      <div className="m-bottom-30">
                        <div className="divider divider-simple text-left">
                          {/* <h3>Savings &amp; Investments</h3> */}
                        </div>
                      </div>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          Native Starch is mostly used for Surface Sizing
                          applications to increase BF, opacity and printability
                          of paper.
                        </li>
                        <li className="list-item arrow-list4">
                          Vijilox/VijiSize is a value added surface sizing
                          starch with a range of different viscosities to suit
                          the requirement of paper / board application
                        </li>
                      </ul>
                      <h4 className="mt-3">Advantages</h4>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          Improves Paper Brightness
                        </li>
                        <li className="list-item arrow-list4">
                          Improves surface strength for both paper & paper
                          board.
                        </li>
                        <li className="list-item arrow-list4">
                          Improves printability and smoothness.
                        </li>
                        <li className="list-item arrow-list4">
                          Compatible with other additives like clay, cmc, wax
                          and other emulsions.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab4"
                    role="tabpanel"
                    aria-labelledby="tab4"
                  >
                    <div className="tab-image m-bottom-50">
                      <img src="img/used/prod4.png" alt="Product 4" />
                    </div>
                    <div className="contents-1">
                      <div className="m-bottom-30">
                        <div className="divider divider-simple text-left">
                          {/* <h3>Business Consulting</h3> */}
                        </div>
                      </div>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          Coating starch is mainly used to replace synthetic
                          binder by a minimum of 4 to 8 parts.
                        </li>
                        <li className="list-item arrow-list4">
                          Printability improves to a great extent and is easily
                          compatible with other additives like Clay, CMC, Wax
                          emulsification and brighteners.
                        </li>
                        <li className="list-item arrow-list4">
                          Improves stiffness of coated paper.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab5"
                    role="tabpanel"
                    aria-labelledby="tab5"
                  >
                    <div className="tab-image m-bottom-50">
                      <img src="img/used/prod5.png" alt="Product 5" />
                    </div>
                    <div className="contents-1">
                      <div className="m-bottom-30">
                        <div className="divider divider-simple text-left">
                          {/* <h3>Online Consulting</h3> */}
                        </div>
                      </div>
                      <p>
                        Starch based, adhesive specially designed for paper
                        tubes, cores, fiber drum applications and corrugation
                        industries.
                      </p>
                      <h4 className="mt-3">Advantages</h4>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          Improves drying time.
                        </li>
                        <li className="list-item arrow-list4">
                          Improves compression strength.
                        </li>
                        <li className="list-item arrow-list4">
                          Improves bonding and stiffness.
                        </li>
                        <li className="list-item arrow-list4">
                          Highly stable product in viscosity and flow ability.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab6"
                    role="tabpanel"
                    aria-labelledby="tab6"
                  >
                    <div className="tab-image m-bottom-50">
                      <img src="img/used/prod6.png" alt="Product 6" />
                    </div>
                    <div className="contents-1">
                      <div className="m-bottom-30">
                        <div className="divider divider-simple text-left">
                          {/* <h3>Strategic Consulting</h3> */}
                        </div>
                      </div>
                      <p>
                        A starch based adhesive, specially designed for
                        corrugation industries.
                      </p>
                      <h4 className="mt-3">Advantages</h4>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          Improves drying time.
                        </li>
                        <li className="list-item arrow-list4">
                          Improves compression strength.
                        </li>
                        <li className="list-item arrow-list4">
                          Improves bonding and stiffness.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab7"
                    role="tabpanel"
                    aria-labelledby="tab7"
                  >
                    <div className="tab-image m-bottom-50">
                      <img src="img/used/prod7.png" alt="Product 7" />
                    </div>
                    <div className="contents-1">
                      <div className="m-bottom-30">
                        <div className="divider divider-simple text-left">
                          {/* <h3>Business Process Services</h3> */}
                        </div>
                      </div>
                      <p>
                        An adhesive to suit latest high speed machines to
                        manufacture paper bags.
                      </p>
                      <h4 className="mt-3">Advantages</h4>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          No Splashing on high speed machines
                        </li>
                        <li className="list-item arrow-list4">
                          Excellent wet strength
                        </li>
                        <li className="list-item arrow-list4">
                          Quick setting and Faster Drying
                        </li>
                        <li className="list-item arrow-list4">
                          Higher Paste Stability
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab8"
                    role="tabpanel"
                    aria-labelledby="tab8"
                  >
                    <div className="tab-image m-bottom-50">
                      <img src="img/used/prod8.png" alt="Product 8" />
                    </div>
                    <div className="contents-1">
                      <div className="m-bottom-30">
                        <div className="divider divider-simple text-left">
                          <h3>Food Grade</h3>
                        </div>
                      </div>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          Maize Starch is a cereal starch having low protein &
                          ash content.
                        </li>
                        <li className="list-item arrow-list4">
                          The PH of starch is always maintained at neutral.
                        </li>
                      </ul>
                      <h4 className="mt-3">Advantages</h4>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          It is easily dispersed in water to make homogeneous
                          solutions.
                        </li>
                        <li className="list-item arrow-list4">
                          It is transformed into a very smooth paste within an
                          hour during cooking.
                        </li>
                        <li className="list-item arrow-list4">
                          Making it suitable as a thickener in Food Industries.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab9"
                    role="tabpanel"
                    aria-labelledby="tab9"
                  >
                    <div className="tab-image m-bottom-50">
                      <img src="img/used/prod9.png" alt="Product 9" />
                    </div>
                    <div className="contents-1">
                      <div className="m-bottom-30">
                        <div className="divider divider-simple text-left">
                          <h3>Gypsum Board Starch</h3>
                        </div>
                      </div>
                      <p>VijiGyp is used in manufacturing of gypsum board</p>
                      <h4 className="mt-3">Advantages</h4>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          Improves strength of board.
                        </li>
                        <li className="list-item arrow-list4">
                          Good bonding strength between paper and gypsum.
                        </li>
                        <li className="list-item arrow-list4">
                          Faster gelatinization
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tab10"
                    role="tabpanel"
                    aria-labelledby="tab10"
                  >
                    <div className="tab-image m-bottom-50">
                      <img src="img/used/prod10.png" alt="Product 10" />
                    </div>
                    <div className="contents-1">
                      <div className="m-bottom-30">
                        <div className="divider divider-simple text-left">
                          <h3>Pregel Starch & Carboxymethyl Starch</h3>
                        </div>
                      </div>
                      <p>
                        Vijidrill and CMS is a cold based water hydratable
                        natural polymer specifically designed for filtration
                        control and rheology stability in oil well drilling
                        applications.
                      </p>
                      <h4 className="mt-3">Advantages</h4>
                      <ul className="arrow--list4">
                        <li className="list-item arrow-list4">
                          It is effective in a wide range of makeup water,
                          including high salinity, high hardness brines.
                        </li>
                        <li className="list-item arrow-list4">
                          It can be used in NaCl, Kcl, MgCl₂, CaCl₂ and
                          compresses brines with a wide range pH.
                        </li>
                        <li className="list-item arrow-list4">
                          It minimizes filtration damage to production zones and
                          proves wellbore stability.
                        </li>
                        <li className="list-item arrow-list4">
                          It is fermentation stable.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-wrapper cta--eight gradient-overlay">
        <div className="container content_above">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <h1 className="color-light m-bottom-50">Connect With Us</h1>
              <Link to="/contact" className="btn btn-warning">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default Products;
